import { NormalImage } from "@/components/image/CustomImage";

const AboutUs = (props) => {
  const { info } = props;
  console.log("info", process.env.BUCKET_URL + info.aboutUsBanner);
  return (
    <div className="text-center py-5">
      <h1 className="text-3xl font-semibold pb-5">About Us</h1>
      {info.aboutUsBanner || info.aboutUsDescription ? (
        <>
          {info.aboutUsBanner && (
            <NormalImage
              alt="About us banner"
              src={process.env.BUCKET_URL + info.aboutUsBanner}
            />
          )}
          <div
            className="text-left md:py-[10px] md:px-[50px]"
            dangerouslySetInnerHTML={{
              __html: info.aboutUsDescription !== "" && info.aboutUsDescription,
            }}
          />
        </>
      ) : (
        <p>No content available</p>
      )}
    </div>
  );
};

export default AboutUs;
